import React from 'react';
import '../../scss/breadcrumbs.scss';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function Breadcrumbs() {
    const navigate = useNavigate();
    const breadcrumbsListValues = useSelector((state) => state.breadcrumbsListValues);
    console.log("Redux", breadcrumbsListValues);

    function Navigate(url) {
        navigate('/'+url);
    }
    return (
        <>
            <div className='breadcrumbs-container'>
                <ul className='breadcrumbs'>
                    {breadcrumbsListValues.map(page => {
                        return (
                            <>
                                <li><span onClick={() => Navigate(page.url)} >{page.name}</span></li>
                            </>
                        )
                    })}
                </ul>
            </div>
        </>
    )
}

export default Breadcrumbs;